<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a progress bar
    *
    * @since 20200414
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <div class="progress" style="height:24px">
            <div v-for="bar in bars" :key="bar.name" :class="get_bar_class(bar)" :style="get_bar_style(bar)" role="progressbar" :aria-valuenow="bar.value" :title="get_title(bar)" :aria-valuemin="min" :aria-valuemax="maxValue">
                <span data-toggle="popover" data-placement="top" data-trigger="hover" :data-content="get_title(bar)" class="hidden-mobile">{{get_title(bar)}}</span>
            </div>
        </div>
        <div v-if="!hideKey">
            <div v-for="bar in bars" :key="bar.name" class="d-inline-flex mt-1">            
                <div class="small"><span :class="bar.color">&emsp; </span>
                <span class="pl-1">{{get_title(bar)}}</span>&emsp;</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: {
            //an array of bars in the progress bar
            bars: {
                type: Array,
                default: []
            },
            //the min value of the progress bar
            min: {
                default: '0'
            },
            //the max value of the progress bar
            max: {
                default: '100'
            },
            //if true, hides the key
            hideKey: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            maxValue: function(){
                var maxV = parseInt(this.max);
                if(maxV > 0){
                    return maxV;
                } else {
                    maxV = 0;
                    for(var i=0; i<this.bars.length; i++){
                        maxV += this.bars[i].value;
                    }
                    return maxV;
                }
            }
        },
        methods: {
            /**
             * returns the style of the bar
             * 
             * @param Object bar the bar
             * 
             * @return String the style
             */
            get_bar_style: function(bar){
                var wid = ((bar.value / this.maxValue)*100).toFixed(2);
                return 'width: ' + wid + '%';
            },
            /**
             * returns the class of the bar
             * 
             * @param Object bar the bar
             * 
             * @return String the class
             */
            get_bar_class: function(bar){
                var clas = 'progress-bar progress-bar-striped'
                if(bar.color !== undefined){
                    clas = clas + ' ' + bar.color;
                }
                return clas;
            },
            /**
             * returns the title of the bar
             * 
             * @param Object bar the bar
             * 
             * @return String the title
             */
            get_title: function(bar){
                if(parseFloat(bar.value) == parseInt(bar.value)){
                    return parseInt(bar.value) + ' ' + bar.name;
                } else {
                    return parseFloat(bar.value).toFixed(2) + ' ' + bar.name;
                }
            }
        }
    }
</script>